import * as THREE from 'three';

export default class Floor extends THREE.Mesh {
  constructor (position, width, height, widthSegments, heightSegments, colour1, colour2) {
    const geom = new THREE.PlaneGeometry(width, height, widthSegments, heightSegments);
    const materialLight = new THREE.MeshLambertMaterial({color: colour1});
    const materialDark = new THREE.MeshLambertMaterial({color: colour2});

    const materials = [materialLight, materialDark];

    let i, j;
    for (let x = 0; x < widthSegments; x++) {
      for (let y = 0; y < heightSegments; y++) {

        i = x * widthSegments + y;
        j = 2 * i;
        geom.faces[j].materialIndex = geom.faces[j + 1].materialIndex = (x + y) % 2
      }
    }

    super(geom, materials);

    this.receiveShadow = true;

    this.position.x = position.x;
    this.position.y = position.y;
    this.position.z = position.z;
  }
}



// WEBPACK FOOTER //
// ./src/entities/floor.js